const translations = {
  Launch: 'Launch (tr)',
  About: 'About (tr)',
  Tutorial: 'Tutorial (tr)',

  // vars
  LoginSubmit: 'Login',
  battery_supervised_only: 'Bu batarya yalnızca denetimli kullanım için kullanılabilir olacaktır.',
  'This action cannot be reversed': 'Bu işlem geri alınamaz.',
  'Are you sure you want to permanently delete': 'Kalıcı olarak silmek istediğinizden emin misiniz',
};

export default translations;
